export const attachmentKeys = {
  upload: ['attachment', 'upload'] as const,
  url: (path?: string) => ['attachment', 'url', path] as const
};
